import { render, staticRenderFns } from "./PagamentosItens.vue?vue&type=template&id=391f918e&scoped=true&"
import script from "./PagamentosItens.vue?vue&type=script&lang=js&"
export * from "./PagamentosItens.vue?vue&type=script&lang=js&"
import style0 from "./PagamentosItens.vue?vue&type=style&index=0&id=391f918e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f918e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VDataTable,VDialog,VSpacer,VToolbar})
